'use client'

import { ReactElement, useEffect } from 'react'

export function TrackingData(props: { dataLayer: string }): ReactElement {
  useEffect(() => {
    const dataLayer = JSON.parse(props.dataLayer) as Record<string, string | number>[]

    window.dataLayer = [...(window.dataLayer || []), ...dataLayer]
  }, [])
  return <></>
}